// extracted by mini-css-extract-plugin
export default {"notice":"EditModeNotice_notice__vjTM9"};